import { KeyedObject } from 'bernie-core/dist/source';

import { CurrentTicketCount } from '../components/activity-details/offer/ticket';
import { ShopWithPointsObject } from '../components/activity-details/offer';

export interface GetTotalPriceBreakdown {
  totalPrice: number;
  discountedPrice: number;
  discount: number;
  totalLeadPoints: number;
  leadingCaption?: string;
  pointsUnit?: string;
  isPointsFirstDisplay?: boolean;
  isStrikeThroughFirstDisplay?: boolean;
}

export const OfferPriceBreakDownHelper = (
  currentTicketCounts: CurrentTicketCount[],
  shoppingWithPoints: ShopWithPointsObject
): KeyedObject => ({
  getTotalPriceBreakdown: (): GetTotalPriceBreakdown => {
    let totalLeadPrice = 0;
    let strikeoutPrice = 0;
    let savingsPercent = 0;
    let totalLeadPoints = 0;
    let pointsUnit;
    let leadingCaption;
    let isPointsFirstDisplay;
    let isStrikeThroughFirstDisplay;

    const isDiscountedTicketSelected = currentTicketCounts
      .filter((t) => t.currentCount > 0)
      .some((t) => t.ticketType.prices[0].perTravelerPrice.strikeOut !== null);

    currentTicketCounts.forEach((t) => {
      if (t.currentCount > 0) {
        const price = t.ticketType.prices.filter((p) => p.selectedCount.toString() === t.currentCount.toString())[0];
        totalLeadPrice += price.totalPrice.lead.amount;
        totalLeadPoints += price.totalLoyaltyPointsOption?.pointsAmount?.raw || 0;
        pointsUnit = price.totalLoyaltyPointsOption?.pointsUnit;
        leadingCaption = price.totalLoyaltyPointsOption?.leadingCaption;
        isPointsFirstDisplay = price.totalLoyaltyPointsOption?.pointsFirst;
        isStrikeThroughFirstDisplay = price.totalLoyaltyPointsOption?.strikeThroughFirst;
        if (price.perTravelerPrice.strikeOut && price.totalPrice.strikeOut) {
          strikeoutPrice += price.totalPrice.strikeOut.amount;
        } else if (isDiscountedTicketSelected) {
          strikeoutPrice += price.totalPrice.lead.amount;
        }
      }
    });

    if (strikeoutPrice > totalLeadPrice) {
      savingsPercent = ((strikeoutPrice - totalLeadPrice) * 100) / strikeoutPrice;
    }

    if (shoppingWithPoints.applied && shoppingWithPoints.value) {
      totalLeadPrice = Math.max(totalLeadPrice - shoppingWithPoints.value, 0);
    }

    return {
      totalPrice: totalLeadPrice,
      discountedPrice: strikeoutPrice,
      discount: savingsPercent,
      totalLeadPoints: totalLeadPoints,
      leadingCaption: leadingCaption,
      pointsUnit: pointsUnit,
      isPointsFirstDisplay: isPointsFirstDisplay,
      isStrikeThroughFirstDisplay: isStrikeThroughFirstDisplay,
    };
  },
});
